<div class="navcard">
  <span
    *ngIf="item.notificationsCount"
    style="
      margin-top: -15px;
      align-self: end;
      width: fit-content;
      align-items: center;
      display: flex;
      border-radius: 50px;
      height: 20px;
      background: #fd5812;
    "
    class="badge badge-light"
    >{{ item.notificationsCount }}</span
  >
  <a
    class="d-flex align-items-center justify-content-center flex-column h-100 w-100"
    [class.disabled]="item.disabled"
    (click)="router.navigate([item.link])"
  >
    <div class="d-flex justify-content-center align-items-center mt-2">
      <app-custom-color-icon [svgPath]="item.imageLink" [size]="40" />
    </div>
    <span
      class="d-flex justify-content-center align-items-center mt-2 cardtext"
    >
      {{ item.name | transloco }}</span
    >
  </a>
</div>
